import services from 'lib_ui-services';
import cuid from 'cuid';

const _p = {
    getSessionData: services.session.getSessionData,
    uiRuntimeConfig: services.uiRuntimeConfig,
    getMqttBrokerHostname: services.getMqttBrokerHostname
};
export const _private = _p;

export default {
    verb: 'willChange',
    namespace: 'rulesEngine',
    relation: 'customerWorkflow',
    description: 'Add in MQTT information if applicable ',
    //this is the actual logic:
    logic
};

async function logic({ data }) {
    const session = await _p.getSessionData();
    // Same broker host Continuous Scan's native MQTT connection uses - see getMqttBrokerHostname.js
    // (lib_ui-services) for the rewrite rules. Previously duplicated inline here; that copy was
    // what let it drift out of sync and miss a rewrite the other one had (#1701).
    const hostname = _p.getMqttBrokerHostname(_p.uiRuntimeConfig.getHostname());
    const { propertyName, newValue } = data;
    if (propertyName === 'actions' && Array.isArray(newValue) && newValue.find(a => a.type.startsWith('forward'))) {
        const i = newValue.findIndex(a => a.type.startsWith('forward'));
        if (newValue[i].username === '<please save for value>') {
            newValue[i].hostname = hostname;
            newValue[i].topic = newValue[i].topic.replace(/\{contractId\}/g, session.tenant['identity:tenant']._id);
            newValue[i].username = randomIntegrationName();
        }
    } else if (propertyName?.startsWith('actions[') && newValue?.type?.startsWith('forward')) {
        newValue.hostname = hostname;
        newValue.username = randomIntegrationName();
        newValue.topic = newValue.topic.replace(/\{contractId\}/g, session.tenant['identity:tenant']._id);
    }
    return data;
}

export function randomIntegrationName() {
    const randomName =
        'i11n_' +
        cuid.slug() +
        '_' +
        Math.floor(Math.random() * 100000000)
            .toString()
            .padStart(8, '0');
    return randomName;
}
